import styled, { css, keyframes } from "styled-components";
import { SkeletonAnimationProps } from "./types";

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

export const SkeletonWrapper = styled.div`
  display: inline-block;
  width: 100%;
`;

export const SkeletonAnimation = styled.div<SkeletonAnimationProps>`
  background: var(--gradient-skeleton);
  background-size: 2000px 100%;
  animation: ${shimmer} ${(props) => props.animationDuration}s ease-in-out
    infinite;
  will-change: background-position;
  contain: layout style paint;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.variant === "text" &&
    css`
      height: ${props.height || "1em"};
      border-radius: 4px;
      transform: scale(1, 0.6);
      margin-top: 0.25em;
      margin-bottom: 0.25em;
    `}
  
  ${(props) =>
    props.variant === "rectangular" &&
    css`
      height: ${props.height || "200px"};
      border-radius: 8px;
    `}
  
  ${(props) =>
    props.variant === "circular" &&
    css`
      width: ${props.width || "40px"};
      height: ${props.height || props.width || "40px"};
      border-radius: 50%;
    `}
`;
